import PropTypes from "prop-types";
import { AsyncDataGridPresetsContext } from "./AsyncDataGridPresetsContext.js";

/**
 * Provides preset actions and state to AsyncDataGrid toolbar and dialogs.
 *
 * @param {Object} props
 * @param {Object|null} props.value
 * @param {import("react").ReactNode} props.children
 */
function AsyncDataGridPresetsProvider({ value, children }) {
  return <AsyncDataGridPresetsContext.Provider value={value}>{children}</AsyncDataGridPresetsContext.Provider>;
}

AsyncDataGridPresetsProvider.propTypes = {
  value: PropTypes.object,
  children: PropTypes.node.isRequired,
};

export default AsyncDataGridPresetsProvider;
